import Card from "./card";
import { Company } from "../types/schema";
import { getImageURL } from "../utils/getImageURL";
import { LinkTo } from "./linkTo";

const cardClasses = "flex h-full w-full rounded-2xl";

export function PressCard({ company }: { company: Company }) {
  return (
    <div className="flip-card h-[190px] w-full">
      <div className="flip-card-inner h-full w-full">
        <div className="flip-card-front h-full w-full">
          <Card
            className={`${cardClasses} items-center justify-center bg-[#F8F8F8]`}
          >
            {company.logo && (
              <img src={getImageURL(company.logo).url()} alt={company.name} />
            )}
          </Card>
        </div>
        <div
          className={`flip-card-back ${cardClasses} bg-green p-0 shadow-none `}
        >
          <Card className="flex items-center justify-center ">
            <div className="flex flex-col gap-4 text-center">
              <div className="line-clamp-3 text-body-15">
                <strong>{company.articleName}</strong>
              </div>

              {company.articleLink && (
                <LinkTo.External
                  url={company.articleLink}
                  className="text-body-13"
                >
                  Read Article
                </LinkTo.External>
              )}
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default PressCard;
